import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
// default setting axios
import "./Utils/IntitialAxios";
// css
import "./css/vendor.css";
import "./css/elephant.css";
import "./css/application.css";
import "./css/custom.css";
import "./css/contacts.css";
import "./css/widgets.css";
import "./css/chartbox.css";
import "./css/datatable.css";
// components
import MsalAuthenticationProvider from "./msal/MsalAuthenticationProvider";
import store from "./store";
import Routs from "./routes";

if (!Array.prototype.find) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.find = function (compareFn) {
    return this.filter(compareFn)[0];
  };
}

document.getElementById("loading-app").classList.remove("loading-app");
document.getElementById("loading-app").classList.add("text-success");

ReactDOM.render(
  <Provider store={store}>
    <MsalAuthenticationProvider>
      <Routs />
    </MsalAuthenticationProvider>
  </Provider>,
  document.getElementById("root")
);
